// @import dependencies
import React, { CSSProperties } from 'react'
// @end dependencies

// @import components
import TextComponent from 'app_components/commons/TextComponent/TextComponent';
// @end components

// @import types
// @end types

// @import services
// @end services

// @import hooks
// @end hooks

// @import actions
// @end actions

// @import utils
// @end utils

// @import assets
// @end assets

// @import styles
import './NewIndicatorComponent.scss'
// @end styles

interface INewIndicatorComponentProps {
  className?: string
  style?: CSSProperties
  id?: string

}

const NewIndicatorComponent: React.FC<INewIndicatorComponentProps> = (props) => {
  return(
    <div
      className={`new_indicator_component-layout ${props.className ? props.className : ''}`}
      style={props.style}
      id={props.id}
    >
      <TextComponent
        type='text'
      >
          Nuevo
      </TextComponent>
    </div>
  );
}

export default NewIndicatorComponent;
